import { Typography } from "@codat/orchard-ui";
import classNames from "classnames";

import styles from "./Logo.module.css";

type LogoImage = {
  src?: string;
  alt?: string;
};

interface LogoProps {
  logo?: LogoImage;
  clientName: string;
  className?: string;
}

export function Logo({ logo, clientName, className, ...props }: LogoProps) {
  const hasLogoImage = !!logo?.src;
  return (
    <div className={classNames(styles.container, className)} {...props}>
      {hasLogoImage ? (
        <img
          data-testid="client-logo"
          className={styles.image}
          src={logo?.src}
          alt={logo?.alt || `${clientName} logo`}
        />
      ) : (
        <Typography
          data-testid="client-name"
          variant="h3"
          as="p"
          className={styles.logoName}
        >
          {clientName}
        </Typography>
      )}
    </div>
  );
}
